import { IconButton, Modal } from "@mui/material";
import Button from "./Button";

import { ModalBox } from "@components/admin/StyledComponents";
import MyAvatar from "../MyAvatar";
import { formatDate } from "@helpers";
import DetailRow from "../DetailRow";
import { useEffect, useState } from "react";
import ReportCount from "./ReportCount";
import PostMedia from "./PostMedia";
import { Close as CloseIcon } from "@mui/icons-material";

export default function PostReportDetail({
  setPostReport,
  postReport,
  actionButtons,
}) {
  const [open, setOpen] = useState(false);
  const user = postReport?.postReported?.user;
  const reporter = postReport?.reportedBy;
  useEffect(() => {
    if (postReport) setOpen(true);
  }, [postReport]);
  if (!postReport) return <div></div>;

  const hanldeDialogClose = () => {
    setPostReport(null);
    setOpen(false);
  }

  const getName = () => {
    if(user)
      return `${user?.firstName} ${user?.lastName}`;
    
    return '[Deleted Post]';
  }

  return (
    <Modal
      open={open}
      onClose={hanldeDialogClose}
    >
      <ModalBox className="shadow-md overflow-auto">
        <div className="flex justify-between items-start">
          <div className="flex gap-6">
            <MyAvatar
              src={user?.media?.currBucketUrl}
              name={getName()}
              subtext={`@${user?.userName ?? `[Deleted Post]`}`}
              textProps={{ className: "font-bold text-gray-600" }}
            />
            <ReportCount count={postReport?.reportCount} />
          </div>

          <IconButton onClick={hanldeDialogClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div>
          <div className="flex gap-8">
            <table className="w-full text-left text-sm mt-5">
              <tbody>
                <DetailRow label="Email:" value={user?.emailAddress ?? '[Deleted Post]'} />
                <DetailRow
                  label="Signin Option:"
                  value={user?.provider || "Email"}
                />
                <DetailRow
                  label="Registration Date:"
                  value={user?.createdAt ? formatDate(user?.createdAt) : '[Deleted Post]'}
                />
                <DetailRow
                  label="Reporter:"
                  value={reporter?.emailAddress}
                />
                <DetailRow
                  label="Reporter Username:"
                  value={reporter?.userName}
                />
                <DetailRow
                  label="Reported On:"
                  value={formatDate(postReport?.createdAt)}
                />
                <DetailRow
                  showFull
                  label="Report Description:"
                  value={postReport?.reason}
                />
              </tbody>
            </table>
            <div className="mt-8">
              <PostMedia post={postReport.postReported} comment={[]} />
            </div>
          </div>
          <div className="flex gap-2 mt-4 justify-end">
            {actionButtons?.map((button, index) => (
              <Button variant="contained" key={index} {...button} />
            ))}
          </div>
        </div>
      </ModalBox>
    </Modal>
  );
}
